import React from 'react'
import PropTypes from 'prop-types'
const Vector = (props) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.33331 12.3267L6.33331 8.32001L8.99998 10.9867L14.6666 4.61334L13.7266 3.67334L8.99998 8.98667L6.33331 6.32001L1.33331 11.3267L2.33331 12.3267Z" fill={props.fill}/>
        </svg>
    )
}
Vector.propTypes = {
    fill: PropTypes.string
}
export default Vector
